import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as QuestionMarkCircle } from 'assets/svg/icon-question-mark-circle.svg'

function IconQuestionMarkCircle(props: IconProps): JSX.Element {
  const title = 'icon-question-mark-circle'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <QuestionMarkCircle {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconQuestionMarkCircle
